import React, { memo, useState, useEffect } from "react"
import { graphql } from "gatsby"
import * as styles from "../page_css/page.css"
import SEOHead from "../components/head"
import { TPerformer } from "../types"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import PageHero from "../components/page-hero"
import * as blocks from "../components/blocks"
import Fallback from "../components/fallback"
import allReusableCards from "../staticQueries/allReusableCards"
import StandardCard from "../components/blocks/StandardCard"
import EventDetails from "../components/event-details"
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import SocialLinks from "../components/social-links"
import {
  breakpoints
} from "../components/ui.css"

export interface MusicProps {
  data: {
    music: TPerformer
  }
}

const getWindowWidth = () => window.innerWidth 
  || document.documentElement.clientWidth 
  || document.body.clientWidth

const desktopBool = () => {
  if (typeof window !== "undefined") {
    return getWindowWidth() > breakpoints[2] ? true : false
  }
}

export default function Music(props: MusicProps) {
  const [isDesktop, setIsDesktop] = useState(desktopBool())
  const [hasWindow, setHasWindow] = useState(false)

  const reusableCards = allReusableCards()
  const ticketCard = reusableCards.filter(card => card.title.includes("Ticket"))[0].cardData[0]

  const music = props.data.music
  const heroImage = music.heroImage? {
    image: music.heroImage,
    overlayColor: music.heroOverlayColor || null,
    overlayOpacity: music.heroOverlayOpacity || null,
  } : null

  const allContent = props.data.music.content?.map((block) => {
    const { id, blocktype, desktopRight, ...componentProps } = block
    const Component = memo(blocks[blocktype] || Fallback)
    const column = desktopRight ? "right" : "left"
    return { 
      column: column,
      component: <Component key={id} id={id} blocktype={blocktype} {...(componentProps as any)} />,
    }
  })

  const leftContent = allContent?.filter(block => block.column == "left")
  const rightContent = allContent?.filter(block => block.column == "right")
    
  useEffect(() => {
    const handleIsDesktop = () => {
      setIsDesktop(desktopBool())
    }
    if (typeof window !== "undefined") {
      setHasWindow(true)
      window.addEventListener('resize', handleIsDesktop);
      return () => {
        window.removeEventListener('resize', handleIsDesktop);
      }
    }
  }, [])




  return (
    <Layout location="music-page">
      {heroImage ? (
        <PageHero title={music.title} {...heroImage} />
      ) :null}
      <div className={styles.pageContainer}>
        {hasWindow && (
          <>
            <section className={`${styles.pageColumn} music`}>
                            
              {!heroImage && (
                <>
                  {music.largeProfileImage ? (
                    <>
                    <GatsbyImage
                      alt={music.avatar.title}
                      className={styles.largeProfileImage}
                      image={getImage(music.largeProfileImage)}
                    />
                    </>
                  ) : (
                    <GatsbyImage
                      className={styles.largeProfileImage}
                      alt={music.avatar.title}
                      image={getImage(music.avatar)}
                    />
                  )}
                  <h1 className={styles.pageHeroTitle} style={{ paddingLeft: 0, marginTop: 0 }}>{music.title}</h1>
                </>
              )}
              
              {
                /*
                <EventDetails {...props.data.music} />
                */
              }
                
                {!props.data.music.content.length && (
                  <div>
                    <ReactMarkdown 
                      remarkPlugins={[remarkGfm]}
                    >{props.data.music.summary}</ReactMarkdown>
                  </div>
                )}
              {!isDesktop ? 
                allContent?.map((block) => block.component ) : 
                leftContent?.map((block) => block.component )
              }

            <SocialLinks performer={music} />
            
            </section>
            {isDesktop && (
              <section className={styles.pageColumn}>
                
                                
                <StandardCard {...ticketCard} />
                
                
                {rightContent?.map((block) => block.component )}
              </section>
            )}
          </>
        )}
      </div>
    </Layout>
  )
}
export const Head = (props: MusicProps ) => {
  const music = props.data.music
  const seoTitle = music.metadata?.title || music.title
  const seoDescription = music.metadata?.description || music.summary
  const seoImage = music.largeProfileImage ? music.largeProfileImage.localFile: music.avatar.localFile
  return <SEOHead title={seoTitle} image={seoImage} description={seoDescription} />
}

export const query = graphql`
  query MusicContent($id: String!) {
    music(id: { eq: $id }) {
      ...PerformerContent
      content {
        ...BlockContent
      }
    }
  }
`